import jquery from 'jquery';
/**
 * @memberof module:ajaxAPI/product
 * @alias get
 *
 * @description Получение отзывов к товару
 *
 * @return {$.ajax}
 *
 * @example
 * ajaxAPI.shop.product.getReviews()
 *  .done(function (onDone) { console.log('onDone:', onDone) })
 *  .fail(function (onFail) { console.log('onFail:', onFail) });
 */

export default function(productId) {
  var link = '/front_api/products/' + productId + '/reviews.json';

  return jquery.getJSON(link);
}
